/*
 *
 * h/t persist.js: https://github.com/jeremydurham/persist-js/blob/master/src/persist.js#L698-L737
 * although this code has been modified, it was originally based on some open source, hence the s/o
 *
 */

// Copyright (c) 2008, 2009 Paul Duncan (paul@pablotron.org)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
//
import { isSSR } from "helpers/client-server-helper";

var ClientStorage = function (clientStorage, namespace) {
  // because, you know, sometimes window.localStorage is present
  // but it is blocked (safari private browsing)
  this.clientStorage = clientStorage || { getItem: () => null, setItem: () => null, removeItem: () => null };
  this.namespace = namespace;
};

ClientStorage.disabled =
  isSSR() ||
  (function (storage) {
    var testString = "availability-test";
    try {
      var disabled = false;

      storage.setItem(testString, testString);
      if (storage.getItem(testString) !== testString) {
        disabled = true;
      }
      storage.removeItem(testString);

      return disabled;
    } catch (e) {
      return true;
    }
  })(window.localStorage);

ClientStorage.prototype = (function () {
  return {
    key: function (key) {
      return this.namespace ? this.namespace + ">" + key : key;
    },

    get: function (key) {
      if (ClientStorage.disabled) {
        return;
      }

      key = this.key(key);

      return JSON.parse(this.clientStorage.getItem(key));
    },

    set: function (key, val) {
      if (ClientStorage.disabled) {
        return;
      }

      key = this.key(key);

      try {
        this.clientStorage.setItem(key, JSON.stringify(val));
      } catch (e) {}

      return val;
    },

    remove: function (key) {
      if (ClientStorage.disabled) {
        return;
      }

      var val;

      key = this.key(key);
      val = this.clientStorage.getItem(key);
      this.clientStorage.removeItem(key);

      return val;
    },

    iterate: function (fn, scope) {
      if (ClientStorage.disabled) {
        return;
      }

      var cs = this.clientStorage,
        key,
        keys,
        ct = 0;
      for (var i = 0; i < cs.length; i++) {
        key = cs.key(i);
        keys = key.split(">");
        if (keys.length === 2 && keys[0] === this.namespace) {
          fn.call(scope || this, keys[1], JSON.parse(cs.getItem(key)));
          ct++;
        }
      }
      return ct;
    },
  };
})();

export const LocalStorage = function (namespace) {
  this.namespace = namespace;

  if (!isSSR()) {
    ClientStorage.call(this, window.localStorage, namespace);
  }
};
LocalStorage.disabled = ClientStorage.disabled;
LocalStorage.prototype = new ClientStorage();
LocalStorage.prototype.constructor = LocalStorage;

export const SessionStorage = function (namespace) {
  this.namespace = namespace;

  if (!isSSR()) {
    ClientStorage.call(this, window.sessionStorage, namespace);
  }
};
SessionStorage.disabled = ClientStorage.disabled;
SessionStorage.prototype = new ClientStorage();
SessionStorage.prototype.constructor = SessionStorage;

export default {
  LocalStorage: LocalStorage,
  SessionStorage: SessionStorage,
};
